import { render, staticRenderFns } from "./FilterPrice.vue?vue&type=template&id=0a16a2ad"
import script from "./FilterPrice.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilterPrice.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports